/** Ziel jeder Weiterleitung nach Sitzungsverlust — die Anmeldung läuft ausschließlich über diese Route. */
export const LOGIN_PATH = '/login';
